module.exports = __webpack_public_path__ + "img/paper-plane.e2a9d566.png";